/* 🤖 this file was generated by svg-to-ts */
export const siriusQuotesPictogram: {
  name: 'quotes_pictogram';
  data: string;
} = {
  name: 'quotes_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 13a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h11.75V13.5a.5.5 0 0 0-.5-.5H7.5Zm11.75 15v2a6.5 6.5 0 0 1-6.5 6.5v2a8.5 8.5 0 0 0 8.5-8.5V13.5a2.5 2.5 0 0 0-2.5-2.5H7.5A2.5 2.5 0 0 0 5 13.5v12A2.5 2.5 0 0 0 7.5 28h11.75ZM29.25 13a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5H41V13.5a.5.5 0 0 0-.5-.5H29.25ZM41 28v2a6.5 6.5 0 0 1-6.5 6.5v2A8.5 8.5 0 0 0 43 30V13.5a2.5 2.5 0 0 0-2.5-2.5H29.25a2.5 2.5 0 0 0-2.5 2.5v12a2.5 2.5 0 0 0 2.5 2.5H41Z" fill="currentColor"/></svg>`
};
